import React, { useEffect, useState } from 'react';

import { DataGrid, Column, Editing, type DataGridTypes, Lookup } from 'devextreme-react/data-grid';
import { RowInsertingEvent, RowRemovingEvent, RowUpdatingEvent } from 'devextreme/ui/data_grid';

import PathType from '../../consts/pathmodule/PathType';

import PathApi from '../../api/PathApi';
import AIGroupApi from '../../api/AIGroupApi';

import AIGroupPathDto from '../../classes/dtos/assistantmodule/AIGroupPathDto';
import PathListDto from '../../classes/dtos/pathmodule/PathListDto';

interface AIGroupPathTemplateProps {
    aiGroupId: number;
    paths: AIGroupPathDto[];
    refresh: () => void;
}

const AIGroupPathTemplate = (props: AIGroupPathTemplateProps) => {
    const { paths: Paths } = props;

    const [paths, setPaths] = useState<PathListDto[] | null>(null);

    useEffect(() => {
        if (paths === null) {
            PathApi.GetPathsAsync(PathType.AI).then((e) => {
                let allPaths = e.Result
                    .toSorted((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : 0);
                setPaths(allPaths);
            });
        }
    }, []);

    const handleOnEditorPreparing = (e: any) => {
        if (e.parentType === 'dataRow' && e.dataField === 'PathId') {
            e.editorOptions.dataSource = paths;
        }
    };

    const handleSourceFieldReferenceIdCalculateDisplayValue = (e: any) => {
        if (paths === null) {
            return;
        }
        let found = paths!.find((x) => x.Id === e.PathId) ?? null;
        return found?.Name ?? "";
    }

    const selectFieldCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {
        if (cellData.value > 0) { return (<div>{cellData.displayValue}</div>); }
        return (<span>{cellData.value || <span style={{ color: "#aaa" }}>Select a field...</span>}</span>);
    };

    function insertRow(e: RowInsertingEvent<AIGroupPathDto, any>) {
        AIGroupApi.CreateAIGroupPathAsync(props.aiGroupId, e.data.PathId)
            .then((e) => {
                if (e.IsFailed()) {
                    alert("ERROR");
                }
                else {
                    props.refresh();
                }
            });
    }

    function updateRow(e: RowUpdatingEvent<AIGroupPathDto, any>) {
        let aiGroupPathId = e.newData.AIGroupPathId ?? e.oldData.AIGroupPathId;
        let aiGroupId = props.aiGroupId;
        let pathId = e.newData.PathId ?? e.oldData.PathId;

        AIGroupApi.UpdateAIGroupPathAsync(aiGroupPathId, aiGroupId, pathId)
            .then((e) => {
                if (e.IsFailed()) {
                    alert("ERROR");
                }
                else {
                    props.refresh();
                }
            });
    }

    function removeRow(e: RowRemovingEvent<AIGroupPathDto, any>) {

        AIGroupApi.DeleteAIGroupPathAsync(e.data.AIGroupPathId)
            .then((e) => {
                if (e.IsFailed()) {
                    alert("ERROR");
                }
                else {
                    props.refresh();
                }
            });
    }

    return (
        <DataGrid
            dataSource={Paths}
            showBorders={true}
            columnAutoWidth={true}
            onEditorPreparing={handleOnEditorPreparing}
            onRowInserting={insertRow}
            onRowUpdating={updateRow}
            onRowRemoving={removeRow}>
            <Editing
                mode="row"
                allowUpdating={true}
                allowDeleting={true}
                allowAdding={true}
                texts={{ addRow: 'Add a new method' }} />
            <Column caption="Path" dataField="PathId" dataType="number" allowEditing={true} calculateDisplayValue={handleSourceFieldReferenceIdCalculateDisplayValue} cellRender={selectFieldCell} editorOptions={{ placeholder: "Select a path..." }}>
                <Lookup
                    displayExpr="Name"
                    valueExpr="Id"
                />
            </Column>
        </DataGrid>
    );
};

export default AIGroupPathTemplate;
